/**
 * Wendet selbst gewaehlte Prioritaetsfarben an (V-04) - an EINER Stelle:
 * sie ueberschreiben die Tokens `--color-prio-*` auf dem Wurzelelement. Alle
 * Punkte in Liste, Matrix und Kalender lesen nur diese Tokens und folgen
 * damit automatisch (Leitlinie 7). Ohne Eintrag gilt der Standard aus
 * tailwind.css.
 */
import { useEffect } from 'react';
import { useLiveQuery } from 'dexie-react-hooks';

import { db } from '@/db/schema';
import type { PriorityColor } from '@/domain/types';

export function PriorityColorsApplier() {
  const eigene = useLiveQuery(() => db.priorityColors.toArray(), [], [] as PriorityColor[]);

  useEffect(() => {
    const root = document.documentElement;
    for (const { id, color } of eigene) root.style.setProperty(`--color-prio-${id}`, color);
    return () => {
      for (const { id } of eigene) root.style.removeProperty(`--color-prio-${id}`);
    };
  }, [eigene]);

  return null;
}
